import { render, staticRenderFns } from "./NewLayout.vue?vue&type=template&id=64623e2f"
import script from "./NewLayout.vue?vue&type=script&lang=js"
export * from "./NewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports